import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { NotificationTheme } from '@fcom/ui-components';

@Component({
  selector: 'fin-flight-selection-warning',
  templateUrl: './flight-selection-warning.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FlightSelectionWarningComponent {
  readonly NotificationTheme = NotificationTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() title: string;
  @Input() warningNotificationMessage: string;
  @Input() warningNotificationCtaText: string;
  @Input() showWarningNotification = true;

  @Output()
  ctaClick: EventEmitter<any> = new EventEmitter();
}
